module.exports = "/_next/static/images/tensorrt-logo-acadd911e0e0f9685bc366695a2763e3.png";